module.exports = function xor(a, b) {
  var len = a.length;
  var i = -1;
  while (++i < len) {
    a[i] ^= b[i];
  }
  return a
};


// WEBPACK FOOTER //
// ./node_modules/public-encrypt/xor.js